<script>
    import FiltersGeneral from '../../app-front/mixins/FiltersGeneral';
    import FilterInfoService from '../../app-front/services/api/FilterInfoService';

    export default {
        name: "BaseSimpleAutocomplete",
        props:[
            'chips',
            'chipsName',
            'externalItems',
            'filterKey',
            'hasExternal',
            'initialModel',
            'label',
            'multiple',
            'resetFilter',
            'resetForce',
            'searchName',
            'itemText',
        ],
        mixins:[FiltersGeneral],
        data() {
            return {
                apiService: FilterInfoService,
                apiUrl: '',
                filterSearch: null,
                isLoading: false,
                items:[],
                searchModel: null,
                searchModels: [],
                params: {},
                storeFilterKey: this.filterKey,
                defaultItemTextPropertyName: 'name',
            }
        },
        computed: {
            componentLabel(){
                return this.label || '';
            },
            filterName() {
                return ''
            },
            hasChips() {
                return !!this.chips;
            },
            itemsList() {
                const list = this.hasExternal ? this.externalItems : this.items;
                const sortVal = this.itemText || this.defaultItemTextPropertyName;
                return list.sort((a, b) => {
                    return a[sortVal].localeCompare(b[sortVal]);
                });
            },
            searchParams() {
                return this.params;
            },
            storeFilter() {
                const storeFiltersContainer = this.$store.state.filters[this.filterKey] || {};

                return storeFiltersContainer[this.filterName] || null;
            }
        },
        methods: {
            checkInitial() {
                if(!this.storeFilter) {
                    return false;
                }

                this.searchModels = [];

                this.itemsList.forEach(item => {
                    if(this.storeFilter.indexOf(item.id) > -1) {
                        if(this.multiple) {
                            this.searchModels.push(item);
                        } else {
                            this.searchModel = item;
                        }
                    }
                });
            },
            getItemsData() {
                if(this.hasExternal) {
                    return false;
                }

                this.setServiceState();
                this.apiService.setLocale(this.$store.state.language.appLanguage);
                this.isLoading = true;

                this.apiService.getSearch(this.searchParams)
                    .then(res => {
                        this.items = res.data;
                        this.isLoading = false;
                        this.checkInitial();
                    })
                    .catch(err => {
                        console.log(err);
                    });
            },
            setChips() {
                if(!this.filterKey || !this.searchName) return false;

                const data = {
                    key: this.filterKey,
                    name: this.searchName,
                    value: this.searchModels,
                };

                if(this.attributeName && Array.isArray(data.value)) {
                    data.value.forEach(item => {
                        item.attributeName = this.attributeName;
                    })
                }

                this.$store.commit('setChips', data);
            },
            setInitialModel(initialModel) {
                if(!initialModel) return false;

                if(this.multiple) {
                    this.searchModel = initialModel;
                } else {
                    this.searchModels = initialModel;
                }
            },
            setServiceState(){
                /*Overwrite this method for set service url*/
            },
            valueChange(){
                let value = [];

                if(this.multiple) {
                    value = this.searchModels.map(item => item.id);
                } else {
                    value = this.searchModel ? [this.searchModel.id] : [];
                }

                const emitData = {
                    name: this.filterName,
                    value: value,
                    key: this.filterKey
                };

                if(this.filterKey && this.filterName) {
                    this.$store.commit('setFilter', emitData);
                    this.setStoreFiltersToUrl();
                }

                this.$emit('value-change', emitData);
            },
            remove(value) {
                this.searchModels = this.searchModels.filter(item => {
                    return item.id !== value;
                });

                this.valueChange();
            },
            resetFilterAction() {
                this.searchModel = null;
                this.searchModels = [];
            }
        },
        created(){
            this.getItemsData();
            this.setInitialModel(this.initialModel);
        },
        watch: {
            resetForce() {
                if(this.resetForce) this.resetFilterAction();
            },
            resetFilter() {
                this.resetFilterAction();
            },
            storeFilter() {
                this.checkInitial();
            }
        }
    }
</script>

<style scoped>

</style>
